/** @copyright (c) Viewpost. All Rights Reserved. See LICENSE for more details. */

import { createApiAction } from 'api/core';

export const getTerms = createApiAction({
  method: 'get',
  url: '/api/webApp/terms',
  queryStringMapper: r => r,
  responseMapper: r => r
});